import type { TenantRole } from '@endcopilot/shared';

export const ROLE_LABEL: Record<TenantRole | 'SUPERADMIN', string> = {
  SUPERADMIN: 'Superadmin Smile',
  TENANT_ADMIN: 'Administrador',
  OPERATOR: 'Operador',
  VIEWER: 'Leitura',
};

export const ROLE_DESCRIPTION: Record<TenantRole, string> = {
  TENANT_ADMIN: 'Gerencia usuários, grupos, dispositivos e políticas da empresa. Exige MFA.',
  OPERATOR: 'Opera dispositivos e envia comandos. Não gerencia usuários nem políticas.',
  VIEWER: 'Somente leitura.',
};

/** Rótulos legíveis para a trilha de auditoria. Ações desconhecidas aparecem com o código. */
export const AUDIT_LABEL: Record<string, string> = {
  'auth.login_succeeded': 'Login realizado',
  'auth.login_failed': 'Falha de login',
  'auth.password_ok_mfa_pending': 'Senha correta, aguardando MFA',
  'auth.mfa_enroll_started': 'Cadastro de MFA iniciado',
  'auth.mfa_enrolled': 'MFA ativado',
  'auth.mfa_failed': 'Código MFA inválido',
  'auth.mfa_recovery_used': 'Código de recuperação usado',
  'auth.mfa_recovery_failed': 'Código de recuperação inválido',
  'auth.mfa_recovery_regenerated': 'Códigos de recuperação regenerados',
  'auth.mfa_reset_by_superadmin': 'MFA resetado por superadmin',
  'auth.refresh_reuse_detected': 'Reuso de sessão detectado (sessões revogadas)',
  'auth.logout': 'Logout',
  'auth.password_changed': 'Senha alterada',
  'tenant.created': 'Empresa criada',
  'user.created': 'Usuário criado',
  'user.linked': 'Usuário existente vinculado',
  'group.created': 'Grupo criado',
  'superadmin.granted': 'Superadmin concedido',
};

export const dateTime = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'medium',
});
